import { TanstackError } from "../client";

export interface SmsConsentResponse {
  success: boolean;
  error?: string;
}

export async function submitSmsConsent(
  consent: boolean,
): Promise<SmsConsentResponse> {
  const response = await fetch("/api/sms-consent", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ consent }),
  });

  const result: SmsConsentResponse = await response.json();

  if (!response.ok || !result.success) {
    throw new TanstackError(
      response.status,
      result.error || "Failed to submit SMS consent",
    );
  }

  return result;
}
